<template>
    <tr>
        <td class="locationColumn" style="width:15%; width:150px;">
            <div class="checkBoxContainer">
                <v-checkbox v-if="showMultiSelect" 
                    color="primary" 
                    v-model="cropLocationVarietyRoster.IsChecked"
                    @change="updateLocationVariertyRowCheckBoxValues()"></v-checkbox>
                <div class="vertical-cell" style="width:15%; width:150px; text-align:left;">
                {{cropLocationVarietyRoster.LocationName}} -  {{cropLocationVarietyRoster.Varieties.length > 1 ? 'Mix' : cropLocationVarietyRoster.Varieties[0].VarietyName}}
                </div>
            </div>
        </td>
        <td v-for="(day, index) in duplicatedDays" :class="`${day.IsVolume ? 'leftBorder' : 'rightBorder'} ${cropLocationVarietyRoster.Days[day.Index].WithholdColour}`"
            @keydown.esc="closeVolume(index, cropLocationVarietyRoster, false)"
            :key="index">
            <div v-if="cropLocationVarietyRoster.Days[day.Index].IsPreviousDay && cropLocationVarietyRoster.NoPreviousDayData">

            </div>
            <div v-else-if="!cropLocationVarietyRoster.Days[day.Index].IsPreviousDay && cropLocationVarietyRoster.PreviousDayOnly">

            </div>
            <div v-else-if="day.IsVolume" class="row">
                <div class="checkBoxContainer">
                    <v-checkbox v-if="showMultiSelect && !day.IsPast && (getRosterValue(cropLocationVarietyRoster.Days[day.Index]) != '' || getRosterValue(cropLocationVarietyRoster.Days[day.Index]) === 0)" 
                        v-model="cropLocationVarietyRoster.Days[day.Index].IsChecked" 
                        color="primary" 
                        style="padding-top: 20px;"></v-checkbox>
                    <div v-if="isSpray(cropLocationVarietyRoster.Days[day.Index])">
                        <RosterLocationNuPointSpray :nuPointSprayModels="cropLocationVarietyRoster.Days[day.Index].NuPointSprayModels"></RosterLocationNuPointSpray>
                    </div>
                    <div v-else class="vertical-cell font-weight-bold"
                    :id="'volume-'+cropLocationVarietyRoster.CropLocationID+'-'+cropLocationVarietyRoster.Varieties.map(v=> v.VarietyID).join('-')+'-'+index"
                    @click="openValueEdit(cropLocationVarietyRoster, day, true)" 
                    @keydown.enter="openValueEdit(cropLocationVarietyRoster, day, true)" 
                    :tabindex="day.IsPast ? null : 0" :ref="cropLocationVarietyRoster.CropLocationID+'-'+day.Index+'-Volume'">
                        <div v-if="isVolumeEditing(cropLocationVarietyRoster.Days[day.Index], day)" style="min-width: 100px;">                           
                            <EditTableCell   
                                :value="getRosterValue(cropLocationVarietyRoster.Days[day.Index]).toString()"
                                @input="modifyVolume(index, cropLocationVarietyRoster, day, $event)"
                                @close="closeVolume(index, cropLocationVarietyRoster, $event)"
                                :rules="[validateRosterValue]"
                                :suffix="uom"
                                :loading="loading">
                            </EditTableCell>
                        </div>
                        <div v-else class="row font-weight-bold">
                            <span v-if="day.IsPast && showActuals" class="px-1">{{cropLocationVarietyRoster.Days[day.Index].ActualsDayValue == null ? 0 : Math.round(cropLocationVarietyRoster.Days[day.Index].ActualsDayValue) | thousandsSeparators}}{{uom}}</span>
                            <span v-else-if="getRosterValue(cropLocationVarietyRoster.Days[day.Index]) != '' || getRosterValue(cropLocationVarietyRoster.Days[day.Index]) === 0">{{getRosterValue(cropLocationVarietyRoster.Days[day.Index]) | thousandsSeparators}}{{uom}}</span>
                            <span v-else>N/A</span>
                            <span>
                                <RosterLocationNuPointSpray :nuPointSprayModels="cropLocationVarietyRoster.Days[day.Index].NuPointSprayModels"></RosterLocationNuPointSpray>                                
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div>
                    <div class="vertical-cell">
                        <div v-if="isTeamSelectionEditing(cropLocationVarietyRoster, day)">
                                <v-select
                                    :items="teamItems"
                                    hide-details
                                    full-width
                                    :value="selectedTeams"
                                    @input="handleTeamSelected"
                                    item-text="TeamName"
                                    item-value="TeamID"
                                    multiple
                                    single-line
                                    dense
                                    item-disabled="disabled"
                                    :menu-props="{value: openTeamSelection, auto: true, overflowY: true}"
                                    >
                                    <template v-slot:prepend-item>
                                        <v-layout class="teamTopSection" @keydown.esc="closeEdit()">
                                            <v-spacer></v-spacer>
                                                <v-btn color="primary" @click="selectTeams(false)" :loading="loading" :ref="'teamSelect'">Select</v-btn>
                                                <v-btn color="error" @click="closeTeamEdit()" :disabled="loading">Cancel</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-layout>
                                        </template>
                                    <template v-slot:selection="data">
                                        <div v-if="selectedTeams.length > 0 && selectedTeams[0] == data.item.TeamID">
                                            <v-chip color="primary" text-color="white" @click="closeTeamEdit()" :tabindex="-1">
                                                <v-avatar class="green darken-4">{{selectedTeams.length}}</v-avatar>
                                                {{data.item.TeamName}}
                                            </v-chip>
                                        </div>
                                    </template>
                                    <template v-slot:item="props">
                                        <v-list-tile >
                                                <v-list-tile-action>
                                                    <v-checkbox :input-value="selectedTeams.find(t=> t == props.item.TeamID) != null" :disabled="props.item.disabled" color="primary" @click.capture="teamItemClick($event, props.item)"></v-checkbox>
                                                </v-list-tile-action>
                                                <v-list-tile-content @click.capture="teamItemClick($event, props.item)" :disabled="props.item.disabled">
                                                    <v-list-tile-title>{{props.item.TeamName}}</v-list-tile-title>
                                                </v-list-tile-content>
                                        </v-list-tile>

                                    </template>
                                </v-select>
                        </div>
                        <div class="row" @click="openTeamEdit(cropLocationVarietyRoster, day)" @keydown.enter="openTeamEdit(cropLocationVarietyRoster, day)" :tabindex="day.IsPast ? null : 0" v-else :ref="cropLocationVarietyRoster.CropLocationID+'-'+day.Index+'-Team'">
                            <v-chip color="error" text-color="white" v-if="isSpray(cropLocationVarietyRoster.Days[day.Index])" :tabindex="-1">
                                SPRAY
                            </v-chip>
                            <v-tooltip lazy bottom v-else-if="canRoster(cropLocationVarietyRoster.Days[day.Index])">
                                <template v-slot:activator="{ on }">
                                    <v-chip color="primary" text-color="white" v-on="on" :tabindex="-1">
                                        <v-avatar class="green darken-4">{{getRosterTeamCount(cropLocationVarietyRoster.Days[day.Index])}}</v-avatar>
                                        {{getRosterTeamDefaultName(cropLocationVarietyRoster.Days[day.Index])}}
                                    </v-chip>
                                </template>
                                <ul>
                                    <li v-for="team in getRosterTeams(cropLocationVarietyRoster.Days[day.Index])"
                                        :key="team.TeamID">{{team.TeamName}} {{getTeamVolume(cropLocationVarietyRoster.Days[day.Index], team.TeamID)}}</li>
                                </ul>
                            </v-tooltip> 
                            <v-chip color="grey" text-color="white" v-else :tabindex="-1">Team</v-chip>
                            <v-icon v-if="day.IsPast || cropLocationVarietyRoster.Days[day.Index].IsPreviousDay">lock_outline</v-icon> 
                        </div>
                    </div>
                </div>
            </div>
        </td>
        <td class="totalVolumeColumn font-weight-bold" style="width:100px; min-width:100px; max-width:100px;">
            <template v-if="!cropLocationVarietyRoster.PreviousDayOnly">
                {{getTotalVolumeForLocation(cropLocationVarietyRoster) | thousandsSeparators}}{{uom}}
            </template>
        </td>
        <td class="totalVarToForecastColumn font-weight-bold" style="width:100px; min-width:100px; max-width:100px;">
            <span v-html="getVarToForecastForLocation(cropLocationVarietyRoster)" v-if="!cropLocationVarietyRoster.PreviousDayOnly">

            </span>
        </td>
        <td class="totalEmptyColumn font-weight-bold" style="width:100px; min-width:100px; max-width:100px;"></td>
        <v-dialog v-model="mixedVarietyTeamDialog" max-width="600" transition="dialog-bottom-transition" @keydown.esc="closeEdit">
            <RosterVarietyTeamDialog :dialog="mixedVarietyTeamDialog" :teamRosterItems="teamRosterItems" 
            :cropLocationDayVarietyRoster="cropLocationDayVarietyRoster"
            :loading="loading"
            :varietyRosterItems="varietyRosterItems" @cancel="closeEdit" @saveTeam="updateTeamMixedRosters" @saveVariety="updateVarietyMixedRosters"/>
        </v-dialog>
        <v-dialog v-model="confirmRemovedTeamDialog"  persistent max-width="400" transition="dialog-bottom-transition" @keydown.esc="confirmRemovedTeamDialog = false">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title >Confirm Deselect Team</v-toolbar-title>
                </v-toolbar>
                <v-layout class="dialog-content">
                    <v-flex xs12>
                        <v-layout wrap>
                            <v-flex xs12 class="ma-2 mb-0">
                                The follow Teams have been deselected, the allocated volumes for these teams will be removed and allocate into the selected teams.
                            </v-flex>
                            <v-flex xs12 class="ma-2 mb-0">
                                <v-list>
                                    <v-list-tile
                                        v-for="teamID in removedTeamIDs"
                                        :key="teamID">
                                        <v-list-tile-action>
                                            <v-icon color="error">fiber_manual_record</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{teams.find(t=> t.TeamID == teamID).TeamName}}</v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-layout>
                        <v-layout wrap class="dialog-action-buttons">
                            <v-flex xs12 sm6>
                                <v-btn block color="success" @click="selectTeams(true)">Confirm</v-btn>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <v-btn block color="error" @click="confirmRemovedTeamDialog = false">Cancel</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <delete-dialog
            :DisplayDialog="showConfirmDeselectSpray" 
            :DialogTitle="'Remove Spray'" 
            :DialogContents="'Are you sure you want to remove the spray from the current selected block?'"
            @No="showConfirmDeselectSpray = false"
            @Yes="teamItemSelect(-1)">
        </delete-dialog>

        <OkPopup
            :DisplayDialog="showNuPointWarning"
            DialogTitle="NuPoint Spray"
            DialogContents="WARNING! Location currently under NuPoint Spray"
            DialogColour="warning"
            DialogIcon="pan_tool"
            @ClickedOK="nuPointWarningDismissed()"
        >
        </OkPopup>
    </tr> 
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import moment from "moment";
import EditTableCell from '@/components/berriesRoster/EditTableCell.vue';
import RosterUtilService from '@/services/rosterUtilService';
import RosterVarietyTeamDialog from '@/components/berriesRoster/RosterVarietyTeamDialog.vue';
import DeleteDialog from "@/components/generic/YesNoPopup.vue";
import OkPopup from '@/components/generic/OkPopup.vue';
import RosterLocationNuPointSpray from '@/components/berriesRoster/RosterLocationNuPointSpray.vue';

export default {

    components: {
        EditTableCell,
        RosterVarietyTeamDialog,
        DeleteDialog,
        OkPopup,
        RosterLocationNuPointSpray
    },
    props: {
        cropLocationVarietyRoster: {
            type: Object,
            required: true
        }
    },
    data(){
        return {
            moment,
            dialog: false,
            loading: false,
            localFilterLocationVarietyName: "",
            teamEditModeIndex: -1,
            editingCropLocationVarieties: null,
            selectedTeams: [],
            originalSelectedTeams: [],
            removedTeamIDs: [],
            openTeamSelection: false,
            teamItems: [],
            mixedVarietyTeamDialog: false,
            teamRosterItems: [],
            varietyRosterItems:[],
            confirmRemovedTeamDialog: false,
            cropLocationDayVarietyRoster: null,
            validateRosterValue(v){
                if(v == null || !v.match(/^[0-9]{1,5}$/)){
                    return "Please enter a number in the form XXXXX";
                }
                return false;
            },
            volumeEditingIndex: -1,
            editingDay: null,
            orignalFocusRef: null,
            valueEditMode: [],
            showConfirmDeselectSpray: false,
            ShowNuPointSprayDetails: false,
            showNuPointWarning: false,
        };
    },
    watch: {
        mixedVarietyTeamDialog: {
            handler(newVal, oldVal) {
                if(newVal == false && oldVal == true) {
                    this.closeEdit();
                }
             
            }   
        },
    },
    computed: {
        ...mapState("RosterStore", [
            "cropLocationVarietyRosters",
            "rosterTeamPlans",
            "teamRosterResult",
            "selectedCategoryIDs",
            "localTeamIDs",
            "showActuals",
            "showMultiSelect"
        ]),
        ...mapGetters("RosterStore", [
            "days",
            "teams",
            "duplicatedDays",
            "uom"
        ])
     },
     methods: {
        ...mapMutations("RosterStore", [
        ]),
        ...mapActions("RosterStore", [
            "updateCropLocationVarietyRosters"
        ]),
        openValueEdit(cropLocationVarietyRoster, day, checkNuPoint) {
            var cropLocationDayVarietyRoster = cropLocationVarietyRoster.Days[day.Index];

            if(day.IsPast || cropLocationDayVarietyRoster.IsPreviousDay) {
                return;
            }

            // If there is team dropdown opened, don't allow inline edit
            if(this.teamEditModeIndex > -1) {
                return;
            }

            if (checkNuPoint && this.isNupointSpray(cropLocationDayVarietyRoster)) {
                this.showNuPointWarning = true;
                this.editingCropLocationVarieties = cropLocationVarietyRoster;
                this.volumeEditingIndex = day.Index;
                return;
            }

            //If it is spray, don't allow the volume to be edited
            if(!this.isSpray(cropLocationDayVarietyRoster)) {
                if(cropLocationDayVarietyRoster.Varieties.length > 1) {
                    this.editingCropLocationVarieties = cropLocationVarietyRoster;
                    // Set the selected team by looping the roster unique team id
                    this.selectedTeams = this.generateSelectedTeamIDs(cropLocationDayVarietyRoster);
                    this.teamEditModeIndex = day.Index;
                    //Open mix popup (teams & varities)
                    this.openMixedPopup(cropLocationDayVarietyRoster);
                } else {
                    this.volumeEditingIndex = day.Index;
                    this.editingDay = cropLocationDayVarietyRoster;
                }
            }
        },
        nuPointWarningDismissed() {
            this.showNuPointWarning = false;
            this.openValueEdit(this.editingCropLocationVarieties, { Index: this.volumeEditingIndex }, false);
        },
        isNupointSpray(cropLocationDayVarietyRoster) {
            return cropLocationDayVarietyRoster.NuPointSprayModels.some(n => n.Withholding);
        },
        isVolumeEditing(cropLocationDayVarietyRoster, day) {
            return this.editingDay != null && this.volumeEditingIndex == day.Index && cropLocationDayVarietyRoster.CropLocationID == this.editingDay.CropLocationID;
        },
        valueCellFocused(cropLocationVarietyRoster, day) {
            var cropLocationDayVarietyRoster = cropLocationVarietyRoster.Days[day.Index];
            if(!this.isSpray(cropLocationDayVarietyRoster)) {
                if(cropLocationDayVarietyRoster.Varieties.length == 1) {
                    this.volumeEditingIndex = day.Index;
                    this.editingDay = cropLocationDayVarietyRoster;
                } 
            }
        },
        isSpray(cropLocationDayVarietyRoster) {
            // If there are roster entry marked as IsSpray, the whole day is considiered Spray
            if(cropLocationDayVarietyRoster == null) {
                return false;
            } else {
                return cropLocationDayVarietyRoster.Varieties.some(v=> v.Rosters.some(s=> s.IsSpray));
            }
        },
        getRosterValue(cropLocationDayVarietyRoster) {
            if(cropLocationDayVarietyRoster == null) {
                return '';
            }
            var rosterDayValue = null;
            cropLocationDayVarietyRoster.Varieties.forEach(v => { 
                var varietyDayValue = null;
                v.Rosters.filter(r=> r.Delete == false).forEach(r => {
                    if(r.RosterValue != null) {
                        if(varietyDayValue == null) {
                            varietyDayValue = parseInt(r.RosterValue);
                        } else {
                            varietyDayValue = varietyDayValue + parseInt(r.RosterValue);
                        }
                    }
                });
                
                if(varietyDayValue != null) {
                    if(rosterDayValue == null) {
                        rosterDayValue = parseInt(varietyDayValue);
                    } else {
                        rosterDayValue = rosterDayValue + parseInt(varietyDayValue);
                    }
                }
            });
            return rosterDayValue == null ? (cropLocationDayVarietyRoster.ForecastDayValue != null ? cropLocationDayVarietyRoster.ForecastDayValue  : '') : (rosterDayValue != null ? rosterDayValue : '');
        },
        async modifyVolume(index, cropLocationVarietyRoster, day, event) {
            var newValue = event.value;
            var isEnter = event.isEnter;
            var cropLocationDayVarietyRoster = cropLocationVarietyRoster.Days[day.Index]; 
            cropLocationDayVarietyRoster.Varieties.forEach(v=> {
                v.Rosters.forEach(r=> {
                    r.RosterValue = parseInt(newValue / (cropLocationDayVarietyRoster.Varieties.length * v.Rosters.length));
                    r.IsSpray = false;
                    r.RequireRecalculate = true;
                    r.Delete = false;
                })

                var newValues = v.Rosters.map(r=> {
                    return r.RosterValue;
                });
                var targetTotal = newValue;
                var currentTotal = newValues.reduce((a, v) => a + v, 0);
                var allocatedValues = RosterUtilService.distrubuteValueEvenly(targetTotal, currentTotal, newValues);
                v.Rosters.forEach((r,i)=> {
                    r.RosterValue = allocatedValues[i];
                });
            });
            await this.updateCropLocationVarieties(cropLocationDayVarietyRoster);
            this.closeVolume(index, cropLocationVarietyRoster, isEnter);
        },
        closeVolume(index, cropLocationVarietyRoster, isEnter = false) {            
            this.volumeEditingIndex = -1;
            this.editingDay = null;
            if(isEnter && cropLocationVarietyRoster.next) {
                this.$nextTick(()=> {
                    document.getElementById('volume-'+cropLocationVarietyRoster.next.CropLocationID+'-'+cropLocationVarietyRoster.next.Varieties.map(v=>v.VarietyID).join('-')+'-'+index).click();
                });
            }
        },
        async updateToSpray(cropLocationVarieties) {
            await this.updateCropLocationVarieties(RosterUtilService.setDaytoSpray(cropLocationVarieties));
        },
        async updateTeamRosters(cropLocationVarieties) {
            await this.updateCropLocationVarieties(RosterUtilService.addUpdateTeamRosters(cropLocationVarieties, this.selectedTeams));
        },
        async updateTeamMixedRosters(teamRosterItems) {
            // Team mixed popup is confirmed and closed, update the allocated team volume to each crop location varieties
            var cropLocationDayVarietyRosters = this.editingCropLocationVarieties.Days[this.teamEditModeIndex];
            await this.updateCropLocationVarieties(RosterUtilService.addUpdateMixedTeamRosters(this.editingCropLocationVarieties, cropLocationDayVarietyRosters, teamRosterItems));
            this.closeEdit();
        },
        async updateVarietyMixedRosters(varietyRosterItems) {
            // Variety mixed popup is confirm and closed, update the allocated variety volume to crop location
            var cropLocationVarieties = this.editingCropLocationVarieties.Days[this.teamEditModeIndex];
            await this.updateCropLocationVarieties(RosterUtilService.addUpdateMixedVarietyRosters(cropLocationVarieties, varietyRosterItems));
            this.closeEdit();
        },
        async updateCropLocationVarieties(cropLocationVarieties) {
            try {
                this.loading = true;
                await this.updateCropLocationVarietyRosters(cropLocationVarieties);
            } catch(e) {
                this.error = e.toString();
            } finally {
                this.loading = false;
            }
        },
        closeEdit() {
            // Close inline edit or mix popup edit
            this.openTeamSelection = false;
            this.teamEditModeIndex = -1;
            this.editingCropLocationVarieties = null;
            this.mixedVarietyTeamDialog = false;
            this.$nextTick(()=> {
                if(this.$refs[this.orignalFocusRef] && this.$refs[this.orignalFocusRef].length > 0) {
                    this.$refs[this.orignalFocusRef][0].focus();
                    this.orignalFocusRef = null;
                }
            })
        },
        generateSelectedTeamIDs(day) {
            return [... new Set(day.Varieties.map(v=> {
                return v.Rosters.map(r=> {
                    return r.TeamID;
                }).flat();
            }).flat().filter(v=> v))];
        },
        openMixedPopup(cropLocationDayVarietyRoster) {
            var mixedPopupItems = RosterUtilService.generateMixedPopupItems(cropLocationDayVarietyRoster, this.editingCropLocationVarieties, this.selectedTeams, this.originalSelectedTeams, this.teams);
            this.teamRosterItems = mixedPopupItems.teamRosterItems;
            this.cropLocationDayVarietyRoster = cropLocationDayVarietyRoster;
            this.varietyRosterItems = mixedPopupItems.varietyRosterItems;
            var dateIndex = new Date(cropLocationDayVarietyRoster.Date).getDay() == 0 ? 6 : (new Date(cropLocationDayVarietyRoster.Date).getDay() -1);
            this.orignalFocusRef = cropLocationDayVarietyRoster.CropLocationID+'-'+dateIndex+'-Team';
            this.mixedVarietyTeamDialog = true;
        },
        getRosterTeams(cropLocationDayVarietyRoster) {     
           return RosterUtilService.getRosterTeams(cropLocationDayVarietyRoster, this.teams);  
        },
        getTeamVolume(cropLocationDayVarietyRoster, teamID) {
            var teamVolume = 0;
            cropLocationDayVarietyRoster.Varieties.forEach(v=> {
                v.Rosters.forEach(r=> {
                    if(r.TeamID == teamID) {
                        teamVolume = r.RosterValue + teamVolume;
                    }
                })
            })
            return `${RosterUtilService.formatThousandsSeparators(teamVolume)}${this.uom}`;
        },
        getRosterTeamDefaultName(cropLocationDayVarietyRoster) {
            return RosterUtilService.getRosterTeamDefaultName(cropLocationDayVarietyRoster, this.teams);
        },
        getRosterTeamCount(cropLocationDayVarietyRoster) {
            if(cropLocationDayVarietyRoster != null) {
                return this.generateSelectedTeamIDs(cropLocationDayVarietyRoster).length;
            } else{
                return 0;
            }
        },
        canRoster(cropLocationDayVarietyRoster) {
            if (!cropLocationDayVarietyRoster) {
                return false;
            }

            return cropLocationDayVarietyRoster.Varieties.length > 0 && cropLocationDayVarietyRoster.Varieties.some(v=> v.Rosters.length > 0 && v.Rosters.some(r=> !r.IsSpray && !r.Delete && r.TeamID != null));
        },
        async selectTeams(confirm) {
            var removedTeamIDs = [];
            var addedTeamIDs = [];

            this.originalSelectedTeams.forEach(teamID => {
                if(this.selectedTeams.indexOf(teamID) < 0) {
                    removedTeamIDs.push(teamID);
                }
            })
            this.selectedTeams.forEach(teamID=> {
                if(this.originalSelectedTeams.indexOf(teamID) < 0) {
                    addedTeamIDs.push(teamID);
                }
            });

            this.removedTeamIDs = removedTeamIDs;

            if (this.showMultiSelect)  {
                //When spray is selected, update the roster day to spray
                if(this.selectedTeams.length === 1 && this.selectedTeams[0] === -1) {
                    this.$emit('multi-update-spray');
                }
                else if(this.selectedTeams.length == 0) {
                    this.$emit('multi-update-team-rosters');
                }
                else {
                    this.$emit('multi-update-team-rosters', this.selectedTeams[0]);
                }

                this.closeEdit();
            } else {
                if(!confirm && removedTeamIDs.filter(t=> t >= 0).length > 0) {
                    this.confirmRemovedTeamDialog = true;
                } else {
                    this.confirmRemovedTeamDialog = false;
                    var cropLocationDayVarietyRoster = this.editingCropLocationVarieties.Days[this.teamEditModeIndex];

                    //When spray is selected, update the roster day to spray
                    if(this.selectedTeams.length === 1 && this.selectedTeams[0] === -1) {
                        await this.updateToSpray(cropLocationDayVarietyRoster);
                        this.closeEdit();
                    }
                    // When no team selected, unallocate theam but keep the value
                    else if(this.selectedTeams.length == 0) {
                        await this.updateTeamRosters(cropLocationDayVarietyRoster);
                        this.closeEdit();
                    }
                    // When there are multiple varieties for the crop location or multiple team selected, open the mixed allocation popup
                    else if(cropLocationDayVarietyRoster.Varieties.length > 1 || this.selectedTeams.length > 1) {
                        // Either there are multiple varieries or multiple team selected
                        this.openMixedPopup(cropLocationDayVarietyRoster);
                    }
                    // Just update the team rostervalue
                    else {
                        await this.updateTeamRosters(cropLocationDayVarietyRoster);
                        this.closeEdit();
                    }
                }
            }     
        },
        handleTeamSelected(value) {
            this.selectedTeams = value;
            this.generateTeamItems();
        },
        teamItemSelect(teamID) {
            // make sure we close this
            this.showConfirmDeselectSpray = false;

            if (this.selectedTeams.indexOf(teamID) > -1) {
                this.selectedTeams.splice(this.selectedTeams.indexOf(teamID), 1);    
            } else {
                if (this.showMultiSelect) {
                    this.selectedTeams = [];
                }

                this.selectedTeams.push(teamID);
            }

            this.handleTeamSelected(this.selectedTeams);
        },
        teamItemClick(event, teamItem) {
            // we have clicked on one of the teams

            // this prevents visual updates to the checkbox even when we don't actually change the underlying data
            event.stopPropagation();

            if (teamItem.disabled) {
                // do nothing!
                return;
            }

            if(teamItem.TeamID == -1 && this.selectedTeams.indexOf(teamItem.TeamID) > -1) {
                // we have clicked on the "Spray" team (-1)
                // it was previously selected, so we are trying to deselect it
                // COSTA1-4134: we need to check before doing this, so we show a prompt before allowing the deselection

                // now we show another dialog, requesting confirmation of the change
                this.showConfirmDeselectSpray = true;
            }
            else {
                this.teamItemSelect(teamItem.TeamID);
            }
        },
        generateTeamItems() {
            if(this.selecteDate) {
                //This filter to show all the team with roster value for the selected product categories
                //Plus all the local new added team from the team management popup
                var rosteredTeamIDs = this.rosterTeamPlans
                .filter(rtp=> rtp.RosterDayOff == false && RosterUtilService.isSameDate(rtp.Date, this.selecteDate))
                .map(rtp=> rtp.TeamID)
                .filter(teamID => {
                    var result = this.teamRosterResult.find(trr=> trr.TeamID == teamID);
                    if(result == null) {
                        return true;
                    } else if(result.ProductCategories.length == 0) {
                        return true;
                    } else {
                        return result.ProductCategories.find(pc=> this.selectedCategoryIDs.some(spt=> spt == pc.ProductCategoryID)) != null || this.localTeamIDs.indexOf(teamID) >= 0;
                    }
                });

                // When IsSpray option is selected, it will disable all the other team options
                // When One team is selected, it will disable IsSpray option
                this.teamItems = this.teams.filter(t=> {
                    return rosteredTeamIDs.indexOf(t.TeamID) >= 0 || t.TeamID == -1;
                }).map(t=> {
                    if(this.selectedTeams.length === 1 && this.selectedTeams[0] === -1 && t.TeamID !== -1) { 
                        t.disabled = true;
                    } 
                    else if (this.selectedTeams.length === 1 && this.selectedTeams[0] !== -1 && t.TeamID === -1) {
                        t.disabled = true;
                    }
                    else if(this.selectedTeams.length > 1 && t.TeamID === -1) {
                        t.disabled = true;
                    } else {
                        t.disabled = false;
                    }
                    return t;
                })
            } else {
                this.closeTeamEdit();
            }
        },
        isTeamSelectionEditing(cropLocationVarieties, day) {
            //Check team dropdown is opening for editing, which prevent multiple selections openning at the same time
            if(this.editingCropLocationVarieties && this.teamEditModeIndex >= 0) {
                if(cropLocationVarieties.CropLocationID == this.editingCropLocationVarieties.CropLocationID && day.Index == this.teamEditModeIndex) {
                    return true;
                }
            } 
            return false;
        },
        getTotalVolumeForLocation(cropLocationVarietyRoster) {
            var volume = 0;

            cropLocationVarietyRoster.Days.forEach(d=> {
                if (!d.IsPreviousDay) {
                    d.Varieties.forEach(v=> {
                        v.Rosters.filter(r=> r.IsSpray == false).forEach(r=> {
                            if(r.RosterValue != null) {
                                volume = volume + parseInt(r.RosterValue);
                            }
                        })
                    });
                }
            });

            return Math.round(volume);
        },
        getVarToForecastForLocation(cropLocationVarietyRoster) {
            var rosterVolume = this.getTotalVolumeForLocation(cropLocationVarietyRoster);
        
            var diff = Math.round(rosterVolume - parseInt(cropLocationVarietyRoster.LocationForecastValue));
            
            if(diff==0) {
                return `<span>${RosterUtilService.formatThousandsSeparators(diff)}${this.uom}</span>`;
            }
            else {
                return `<span class='error--text'>${RosterUtilService.formatThousandsSeparators(diff)}${this.uom}</span>`;
            }
        },
        openTeamEdit(cropLocationVarietyRoster, day) {
            var cropLocationDayVarietyRoster = cropLocationVarietyRoster.Days[day.Index];

            if(day.IsPast || cropLocationDayVarietyRoster.IsPreviousDay) {
                return;
            }

            // If there is team dropdown opened, don't open another team dropdown
            if(this.teamEditModeIndex > -1) {
                return;
            }
            this.teamEditModeIndex = day.Index;
            this.editingCropLocationVarieties = cropLocationVarietyRoster;

            // Set the selected unique team id
            this.selectedTeams = this.generateSelectedTeamIDs(cropLocationDayVarietyRoster);
            this.originalSelectedTeams = this.generateSelectedTeamIDs(cropLocationDayVarietyRoster);
            // It should only have one entry if the day is for spray
            if(cropLocationVarietyRoster.Days[day.Index].Varieties.some(v=> v.Rosters.some(r=> r.IsSpray))) {
                this.selectedTeams = [-1];
            }
            this.selecteDate = cropLocationDayVarietyRoster.Date;
            this.generateTeamItems();
            this.orignalFocusRef = cropLocationDayVarietyRoster.CropLocationID+'-'+(new Date(cropLocationDayVarietyRoster.Date).getDay()-1)+'-Team';
            this.$nextTick(() => {
                this.openTeamSelection = true;
                setTimeout(() => {
                    this.$refs['teamSelect'][0].$el.focus();
                }, 100);
            });
        },
        closeTeamEdit() {
            this.teamEditModeIndex = -1;
            this.originalSelectedTeams = [];
            this.editingCropLocationVarieties = null;
            this.selectedTeams = [];
            this.openTeamSelection = false;
            this.selecteDate = null;

            this.$nextTick(()=> {
                if(this.$refs[this.orignalFocusRef] && this.$refs[this.orignalFocusRef].length > 0) {
                    this.$refs[this.orignalFocusRef][0].focus();
                    this.orignalFocusRef = null;
                }
            });
        },
        updateLocationVariertyRowCheckBoxValues() {
            this.cropLocationVarietyRoster.Days.forEach((d, index) => {
                if (!d.IsPast) {
                    this.$set(this.cropLocationVarietyRoster.Days, index, {
                        ...d,
                        IsChecked: this.cropLocationVarietyRoster.IsChecked
                    });
                }
            });
        },
     }
    
}
</script>

<style scoped>
.ica-icon {
    font-size: 11px;
    width: 26px;
    justify-content: center;
}
.vertical-cell {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.row {
    height: 55px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
}
.roster-localtion-table-scroll {
    position: absolute;
    z-index: 1;
    overflow: auto;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    min-height: 100px;
}

.roster-localtion-table-scroll table {
    width: 100%;
    height: 100%;
    margin: auto;
}

.roster-localtion-table-scroll table tr td, .roster-localtion-table-scroll table tr th {
    width: auto;
    font-size:18px;
}

.roster-location-table-scroll thead {
    background-color: #449144 ;
}

.roster-localtion-table-scroll thead tr td, .roster-localtion-table-scroll thead tr th {
    position: -webkit-sticky;
    position: sticky;
    z-index: 5;
    background-color: #449144 ;
    z-index: 5;
    color: white;
}

.roster-localtion-table-scroll thead tr:nth-child(1) td, .roster-localtion-table-scroll thead tr:nth-child(1) th {
    top: 0px;
    height: 40px!important;
    max-height: 40px;
    min-height: 40px;
}

.roster-localtion-table-scroll thead tr:nth-child(2)  {
    height: 20px;
}

.roster-localtion-table-scroll thead tr:nth-child(2) td, .roster-localtion-table-scroll thead tr:nth-child(2) th {
    top: 55.56px;
    height: 20px;
}

.roster-localtion-table-scroll tr:nth-child(1) th:nth-child(1) {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 25;
}

 
.roster-localtion-table-scroll tr:nth-child(1) th:nth-last-child(1) {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 25;
}

.roster-localtion-table-scroll tr:nth-child(1) th:nth-last-child(2) {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 100;
}

.roster-localtion-table-scroll tr:nth-child(1) th:nth-last-child(3) {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 100;
}

.roster-localtion-table-scroll .fillerRow th, .fillerRow td {
    height: auto;
}

.roster-localtion-table-scroll .v-table thead tr:first-child {
    border-bottom: none;
}

.roster-localtion-table-scroll .v-table thead tr:nth-child(2) {
    border-bottom: 1px solid rgba(0,0,0,0.12);
}
.roster-localtion-table-scroll .leftBorder {
    border-left: 1px solid rgba(0,0,0,0.12);
    padding:0px;
    margin:0px;
    min-width: 120px;
    max-width: 120px;
    width: 120px;
}

.roster-localtion-table-scroll .rightBorder {
    border-right: 1px solid rgba(0,0,0,0.12);
    padding:0px;
    margin:0px;
    min-width: 125px;
    max-width: 125px;
    widows: 125px;;
}
.roster-localtion-table-scroll .small-cell {
        min-height: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
}

 .locationColumn {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
    z-index: 10;
    background: white;
}

.totalVarToForecastColumn {
    position: -webkit-sticky;
    position: sticky;
    right: 100px;
    z-index: 10;
    background: white; 
}

.totalVolumeColumn {
    position: -webkit-sticky;
    position: sticky;
    right: 200px;
    z-index: 10;
    background: white; 
}

.totalEmptyColumn {
    position: -webkit-sticky;
    position: sticky;
    right: 0;
    z-index: 10;
    background: white; 
}

.teamTopSection {
    position: sticky;
    top: 4px;
    left: 0;
    right: 0;
    z-index: 99;
    background: white;
}

.checkBoxContainer {
    display: flex; 
    justify-content: space-between; 
    align-items: center;
}
</style>